import { useEffect, RefObject } from "react";

/**
 * Hook to expose a form submit function to parent component via a ref
 * @param formRef - Reference to the HTML form element
 * @param onSubmitFormRef - Mutable ref from parent to receive the submit function
 */
export const useExposeSubmit = (
    formRef: RefObject<HTMLFormElement>,
    onSubmitFormRef?: React.MutableRefObject<(() => void) | null>
): void => {
    useEffect(() => {
        if (onSubmitFormRef) {
            onSubmitFormRef.current = () => {
                if (formRef.current) {
                    formRef.current.requestSubmit();
                }
            };
        }

        // Cleanup: reset the ref when the component is unmounted
        return () => {
            if (onSubmitFormRef) {
                onSubmitFormRef.current = null;
            }
        };
    }, [formRef, onSubmitFormRef]);
};
